import { pathToUrl } from "utils/url";

import { MAIN_ROUTE, PATHS } from "../constants";
import { TiVoDeviceTab } from "./components/TiVoDeviceTabs";
import { TEXTS } from "./constants";

export function getOemTabs(
  platformId?: string,
  oemId?: string
): TiVoDeviceTab[] {
  if (location.pathname.startsWith(`/${MAIN_ROUTE}/create`)) {
    return [];
  }
  return [
    {
      label: TEXTS.OEM_DETAILS_TAB,
      link: pathToUrl(PATHS.detailsOem, { platformId, oemId }),
    },
    {
      label: TEXTS.OEM_EDIT_TAB,
      link: pathToUrl(PATHS.editOem, { platformId, oemId }),
      adminOnly: true,
    },
    {
      label: TEXTS.APPLICATIONS_TAB,
      link: pathToUrl(PATHS.applicationsOem, { platformId, oemId }),
    },
  ];
}

export function getClientTypeTabs(
  platformId?: string,
  oemId?: string,
  clientTypeId?: string
): TiVoDeviceTab[] {
  if (location.pathname.startsWith(`/${MAIN_ROUTE}/create`)) {
    return [];
  }
  return [
    {
      label: TEXTS.CLIENT_DETAILS_TAB,
      link: pathToUrl(PATHS.detailsClientType, {
        platformId,
        oemId,
        clientTypeId,
      }),
    },
    {
      label: TEXTS.CLIENT_EDIT_TAB,
      link: pathToUrl(PATHS.editClientType, {
        platformId,
        oemId,
        clientTypeId,
      }),
      adminOnly: true,
    },
    {
      label: TEXTS.APPLICATIONS_TAB,
      link: pathToUrl(PATHS.applicationsClientType, {
        platformId,
        oemId,
        clientTypeId,
      }),
    },
  ];
}
